import Cookies from 'js-cookie';
import { useState } from 'react';
import { env } from 'next-runtime-env';

const TOKEN_NAME = 'auth_token';
const USER_ID = 'user_id';

export const setAuthToken = (token: string) => {
  Cookies.set(TOKEN_NAME, token, {
    expires: 0.5, // 12 hrs
    secure: env('NEXT_PUBLIC_ENV') !== 'dev',
    sameSite: 'lax',
  });
};

export const getAuthToken = () => {
  return Cookies.get(TOKEN_NAME);
};

export const removeAuthToken = () => {
  Cookies.remove(TOKEN_NAME);
};

export const setUseridToken = (token: string) => {
  Cookies.set(USER_ID, token, {
    expires: 15 / (24 * 60), // ~15 mins
    secure: env('NEXT_PUBLIC_ENV') !== 'dev',
    sameSite: 'Strict',
  });
};

export const getUseridToken = () => {
  return Cookies.get(USER_ID);
};

export const removeUseridToken = () => {
  Cookies.remove(USER_ID);
};

export const signout = () => {
  removeAuthToken();
  removeUseridToken();
  // Optionally, you can also clear other user-related data here
};

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    // Initialize auth state based on token presence
    if (typeof window !== 'undefined') {
      return !!getAuthToken();
    }
    return false;
  });

  const login = (token: string) => {
    setAuthToken(token);
    setIsAuthenticated(true);
  };

  const logout = () => {
    signout();
    setIsAuthenticated(false);
  };

  return {
    isAuthenticated,
    login,
    logout,
  };
};
